import { PcbNodeTypes } from "@buildwithflux/models";
import { Box3, Vector3 } from "three";
/**
 * Gets the bounding box for a pad node based on its baked rules.
 */
export const getBoundsForPad = (pad) => {
    const expansion = Math.max(pad.bakedRules.solderMaskExpansion?.bottomExpansion ?? 0, pad.bakedRules.solderMaskExpansion?.topExpansion ?? 0, pad.bakedRules.solderPasteMaskExpansion ?? 0);
    return new Box3().setFromCenterAndSize(new Vector3(), new Vector3(pad.bakedRules.scale.x * pad.bakedRules.size.x + expansion * 2, pad.bakedRules.scale.y * pad.bakedRules.size.y + expansion * 2, 0));
};
/**
 * Get the bounding box for a PCB node.
 */
export const getBoundsForNode = (node) => {
    switch (node.type) {
        case PcbNodeTypes.pad:
            return getBoundsForPad(node);
        default:
            return null;
    }
};
export const AABB = {
    getBoundsForPad,
    getBoundsForNode,
};
//# sourceMappingURL=aabb.js.map